package fr.manyverse.app.infrastructure.repository

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonPrimitive

internal fun extractString(value: Any?): String? = when (value) {
    null -> null
    is JsonPrimitive -> value.content
    is String -> value
    else -> value.toString()
}

internal fun extractStringList(json: Json, value: Any?): List<String> = when (value) {
    null -> emptyList()
    is List<*> -> value.mapNotNull { extractString(it) }
    is JsonArray -> value.mapNotNull { (it as? JsonPrimitive)?.content }
    is JsonPrimitive -> {
        try {
            json.decodeFromString<List<String>>(value.content)
        } catch (_: Exception) {
            listOf(value.content)
        }
    }
    is String -> {
        try {
            json.decodeFromString<List<String>>(value)
        } catch (_: Exception) {
            listOf(value)
        }
    }
    else -> emptyList()
}

internal fun extractBoolean(value: Any?): Boolean? = when (value) {
    null -> null
    is Boolean -> value
    is JsonPrimitive -> value.content.toBooleanStrictOrNull()
    is String -> value.toBooleanStrictOrNull()
    else -> null
}

internal fun extractInt(value: Any?): Int? = when (value) {
    null -> null
    is Number -> value.toInt()
    is JsonPrimitive -> value.content.toIntOrNull()
    is String -> value.toIntOrNull()
    else -> null
}
